import React from 'react';
import { CheckedItemContentfulModel } from 'src/api/models/CheckedItem';
import CheckedItem from 'src/molecules/checklist/checked.item';
import styled from 'styled-components';

const DynamicCheckedItemContainer = styled.div`
  display: flex;
  justify-content: center;
`

export default function getDynamicCheckedItem(checkedItemProps: CheckedItemContentfulModel): React.ReactNode {
  return (
    <DynamicCheckedItemContainer>
      <CheckedItem checked={checkedItemProps.checked} text={checkedItemProps.text} />
    </DynamicCheckedItemContainer>
  )
}
